<template>
    <div class="wrapper">
        <!-- 导航 -->
        <div class="nav-bar flex">
            <el-dropdown class="avatar-container right-menu-item" trigger="click">
                <div class="avatar-wrapper">
                    <i class="el-icon-user-solid"></i>
                    <span>用户{{userId}}</span>
                    <i class="el-icon-caret-bottom" />
                </div>
                <el-dropdown-menu slot="dropdown" class="nav-bar-dropdown">
                    <el-dropdown-item>
                        <span style="display:block;" @click="passDialog = true">
                            <i class="el-icon-edit"></i>
                            修改密码</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <span style="display:block;" @click="logout">
                            <i class="el-icon-switch-button"></i>
                            退出登录</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <el-dialog
                title="修改密码"
                :close-on-click-modal="false"
                :visible.sync="passDialog"
                width="50%">
            <el-form ref="userForm" label-width="60px" class="demo-ruleForm">
                <el-form-item label="新密码" prop="">
                    <el-input name="newPass"
                          type="text"
                          v-model="newPass"
                          placeholder=""
                    />
                    <p class="tip">1.密码必须包含大写字母、小写字母、数字和特殊字符(~!@#$%^&*)</p>
                    <p class="tip">2.同一数字或字母不能连续出现4次</p>
                    <p class="tip">3.长度至少12位</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passDialog = false">取 消</el-button>
                <el-button type="primary" @click="modifyPass" :loading="loading">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 内容区 -->
        <section class="app-main">
            <transition name="fade-transform" mode="out-in">
                <router-view></router-view>
            </transition>
        </section>
    </div>
</template>

<script>
import { getCookies, removeCookies } from '@/utils/auth.js';
import { updatePassword } from '@/graphql/graphql.js';
export default {
    data() {
        return {
            userId: getCookies('userId'),
            passDialog: false,
            loading: false,
            newPass: ''
        };
    },
    methods: {
        modifyPass() {
            const reg = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*])(?!.*(.)\1{3}).{12,}$/;
            if (!this.newPass) {
                this.$message({
                    message: '密码为空',
                    type: 'error',
                    duration: 3000
                });
                return;
            }
            if (!reg.test(this.newPass)) {
                this.$message({
                    message: '密码设置不规范',
                    type: 'error',
                    duration: 3000
                });
                return;
            }
            this.loading = true;
            this.$apollo.mutate({
                mutation: updatePassword,
                variables: {
                    userId: Number(this.userId),
                    newPassword: this.newPass
                }
            }).then(res => {
                const result = res.data.updatePassword;
                this.loading = false;
                if (result && result.code === 200) {
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.passDialog = false;
                } else {
                    this.$message({
                        message: result.message,
                        type: 'error'
                    });
                }
            }).catch(error => {
                this.loading = false;
                this.$message({
                    message: error.message,
                    type: 'error'
                });
            });
        },
        logout() {
            removeCookies('userToken');
            removeCookies('userId');
            window.location.href = `https://www.madagx.com/wxauth/login.html?appid=wx7e700089d1cc517d&scope=snsapi_login&state=${Math.ceil(Math.random() * 1000)}&redirect_uri=${encodeURIComponent('https://styw.madagx.com')}`;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue